import React from 'react';
import EntityDetailDialog from '../../../../shared/components/EntityDetailDialog';
import { getAutomationTotalSavedTime } from '@/modules/automations/utils';
import TimeFilterSelect from './TimeFilterSelect';
import UsageByPeriodChart from './UsageByPeriodChart';
import UsageByUserChart from './UsageByUserChart';

function getInitials(value = '') {
  const parts = String(value).trim().split(/\s+/).filter(Boolean);
  return parts.length ? parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase() : 'AU';
}

export default function AutomationDetailsDialog({
  open,
  onOpenChange,
  automation,
  timeFilter,
  onTimeFilterChange,
  timeFilters,
  periodData,
  userData,
  totalUsage,
}) {
  if (!automation) return null;

  const totalSavedTime = getAutomationTotalSavedTime(automation);

  return (
    <EntityDetailDialog
      isOpen={open}
      onClose={() => onOpenChange?.(false)}
      title={`Dettagli Automazione: ${automation.nome}`}
      subtitle="Analisi utilizzo e tempo risparmiato"
      avatarLabel={getInitials(automation.nome)}
      badges={[{ label: 'Automazione', tone: 'active' }]}
      className="automation-detail"
    >
      <div className="space-y-5">
        <section className="entity-detail-dialog__card">
          <TimeFilterSelect
            options={timeFilters}
            value={timeFilter}
          onChange={onTimeFilterChange}
            totalUsage={totalUsage}
          />
        </section>

        <section className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <UsageByPeriodChart filter={timeFilter} data={periodData} />
          <UsageByUserChart data={userData} />
        </section>

        <section className="entity-detail-dialog__card">
          <div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-2 lg:grid-cols-4">
            <div>
              <p className="text-xs text-[var(--text-secondary)]">Utilizzi Totali</p>
              <p className="text-lg font-bold text-[var(--text-primary)]">{automation.utilizziTotali}</p>
            </div>
            <div>
              <p className="text-xs text-[var(--text-secondary)]">Questo Mese</p>
              <p className="text-lg font-bold text-[var(--primary)]">{automation.utilizziMese}</p>
            </div>
            <div>
              <p className="text-xs text-[var(--text-secondary)]">Tempo Risparmiato</p>
              <p className="text-lg font-bold text-[var(--success-text)]">
                {totalSavedTime.hours}h {totalSavedTime.minutes}m
              </p>
            </div>
            <div>
              <p className="text-xs text-[var(--text-secondary)]">Media Giornaliera</p>
              <p className="text-lg font-bold text-[var(--chart-accent-1)]">~3 utilizzi</p>
            </div>
          </div>
        </section>
      </div>
    </EntityDetailDialog>
  );
}
